import { render } from "./refferals-table.vue?vue&type=template&id=7aa9100c"
import script from "./refferals-table.vue?vue&type=script&lang=js"
export * from "./refferals-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__